import { SimpleList } from "@/components/list";

export const OFFERINGS_CONSTANTS = {
  title: "What Makes Our Network Access Platform Modern? ",
  desc: "As security perimeters dissolve, OneMind goes beyond static policies — integrating intelligence, behavior analytics, and global threat context into every access decision. ",
  list: [
    {
      title: "Threat Intelligence Integration ",
      subTitle: "See the threat landscape as it evolves — in real time. ",
      content: (
        <SimpleList
          points={[
            "Fuses behavioral analytics with global threat intel feeds from partners like Sophos and Check Point",
            "Correlates known IOCs and tactics with real-time telemetry from endpoints, users, and the network",
            "Enables faster detection of emerging malware, botnets, and nation-state actors",
            "Feeds context into ZTNA, VPN, and NGFW policies to adjust risk levels dynamically",
          ]}
        />
      ),
      conclusion: "Stay one step ahead — block malicious access before it happens. ",
    },
    {
      title: "MITRE ATT&CK Framework Alignment ",
      subTitle: "Understand and respond to attacks the way adversaries think. ",
      content: (
        <SimpleList
          points={[
            "All detections and responses are mapped to the MITRE ATT&CK® framework",
            "Helps security teams understand the tactics, techniques, and procedures (TTPs) behind each event",
            "Enables real-time threat titleing, red/blue team exercises, and automated response playbooks",
            "Brings alignment to SASE and NGFW threat intelligence layers",
          ]}
        />
      ),
      conclusion: "Don’t just detect threats — understand their intent. ",
    },
    {
      title: "Attack Surface Management (ASM) ",
      subTitle: "ZTNA starts with knowing what you’re defending. ",
      content: (
        <SimpleList
          points={[
            "Continuous visibility across cloud, on-prem, and remote environments",
            "Identifies misconfigured assets, shadow IT, and third-party exposure",
            "Surfaces risks associated with abandoned endpoints, VPN overuse, and ungoverned access",
            "Prioritizes based on exploitability, exposure level, and business impact",
          ]}
        />
      ),
      conclusion: "Reduce your attack surface before attackers discover it. ",
    },
  ],
};
